module.exports={author:"Dan Beachy-Quick",date:"02/09/2021",publishDate:"10/16/2020",highlighted:!1,tags:"",title:"Mnemosyne in Tatters"};